export default __webpack_public_path__ + "static/media/bq.f8636213.jpg";